import { ReactComponent as KatakanaProfile } from 'assets/katakana-profile.svg';
import ProfileImg from 'assets/mehdifbphoto.jpg';
import ProfileImgPlaceholder from 'assets/profile-placeholder.jpg';
import classNames from 'classnames';
import { Button } from 'components/Button';
import DecoderText from 'components/DecoderText';
import Divider from 'components/Divider';
import Heading from 'components/Heading';
import Image from 'components/Image';
import Link from 'components/Link';
import Section from 'components/Section';
import Text from 'components/Text';
import { Fragment } from 'react';
import { Transition } from 'react-transition-group';
import { media } from 'utils/style';
import { reflow } from 'utils/transition';
import './Profile.css';
import Skills from './Skills';

const ProfileText = ({ status, titleId }) => (
  <Fragment>
    <Heading
      className={classNames('profile__title', `profile__title--${status}`)}
      level={3}
      id={titleId}
    >
      <DecoderText text="Hi there" start={status !== 'exited'} delay={500} />
    </Heading>
    <Text
      className={classNames('profile__description', `profile__description--${status}`)}
      size="l"
    >

      I am Mehdi, currently working as Front-End Team Leader at <Link href="https://besedo.com/fr/">Besedo</Link>.
      I spend most of my day, experimenting with HTML, CSS and JavaScript (and its endless list of frameworks).
      I love best practices and the challenge of learning something new everyday.
      I'm always interested in new projects, so feel free to drop me a line.
      {/* Last but not least, I’m a good team player and can communicate with people from various backgrounds and with different personalities. */}
      {/* I’m Hamish, currently I live in Sydney working as a senior product designer at{' '}
       My projects include UX design, UI
      animations, and icon illustration. Being comfortable with code allows me to rapidly
      prototype and validate experiences. If you're interested in the tools and software I
      use check out my <Link href="/uses">uses page</Link>. */}
    </Text>
    {/* <Text
      className={classNames('profile__description', `profile__description--${status}`)}
      size="l"
    >
      In my spare time I like to practice Brazilian Jiu Jitsu, play video games, and{' '}
      <Link href="/projects/volkihar-knight">make mods</Link>. I’m always down for hearing
      about new projects, so feel free to drop me a line.
    </Text> */}
  </Fragment>
);

const Profile = ({ id, visible, sectionRef }) => {
  const titleId = `${id}-title`;

  return (
    <Section
      className="profile"
      as="section"
      id={id}
      ref={sectionRef}
      aria-labelledby={titleId}
      tabIndex={-1}
    >
      <Transition in={visible} timeout={0} onEnter={reflow}>
        {status => (
          <div className="profile__content">
            <div className="profile__column">
              <ProfileText status={status} titleId={titleId} />
              
              <Button
                secondary
                className={classNames('profile__button', `profile__button--${status}`)}
                href="/contact"
                icon="send"
              >
                Send me a message
              </Button>
              <Skills status={status} />
            </div>
            <div className="profile__column">
              <div className="profile__tag" aria-hidden>
                <Divider
                  notchWidth="64px"
                  notchHeight="8px"
                  collapsed={status !== 'entered'}
                  collapseDelay={1000}
                />
                <div
                  className={classNames(
                    'profile__tag-text',
                    `profile__tag-text--${status}`
                  )}
                >
                  About Me
                </div>
              </div>
              <div className="profile__image-wrapper">
                <Image
                  reveal
                  delay={100}
                  placeholder={ProfileImgPlaceholder}
                  srcSet={`${ProfileImg} 480w, ${ProfileImg} 960w`}
                  sizes={`(max-width: ${media.mobile}px) 100vw, 480px`}
                  alt="Mehdi Jarraya profile picture"
                />
                <KatakanaProfile
                  className={classNames('profile__svg', `profile__svg--${status}`)}
                />
              </div>
            </div>
          </div>
        )}
      </Transition>
    </Section>
  );
};

export default Profile;
